import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import styles from "./RelatedPosts.module.scss";
import getClasses from "utils/getClasses";
import { Col, Container, Row } from "react-bootstrap";
import queryBlogEntry from "services/queryBlogEntry";
import { useEffect, useMemo, useState } from "react";
import BlogCard from "../blog-card/BlogCard";
import { AmplitudePageName } from "utils/amplitude";

interface RelatedPostsProps {
  blog: Blog | null;
  category: string;
  amplitudePageName: AmplitudePageName;
}

const RelatedPosts = ({
  blog,
  category,
  amplitudePageName,
}: RelatedPostsProps) => {
  const { isPhonePortrait } = usePhonePortraitContext();
  const [blogs, setBlogs] = useState<Blog[]>([]);

  const currentBlogId = useMemo(() => blog?.id ?? "", [blog]);

  useEffect(() => {
    queryBlogEntry()
      .then((res) => setBlogs(res || []))
      .catch(console.error);
  }, []);

  const relatedPosts = useMemo(
    () =>
      blogs
        .filter((blog) => blog.id !== currentBlogId)
        .sort((a, b) => (a.create_datetime < b.create_datetime ? 1 : -1))
        .slice(0, 3),
    [blogs, currentBlogId],
  );

  return (
    <Container
      className={getClasses(
        styles["related-posts"],
        isPhonePortrait && styles["related-posts--phone"],
      )}
    >
      <div className={styles["title"]}>Related posts</div>
      <div className={styles["description"]}>
        Looking to learn more? The below posts maybe helpful for you to learn
        more about {category}.
      </div>
      <Row className={styles["list"]}>
        {relatedPosts.map((blog) => (
          <Col
            xs={12}
            md={4}
            lg={4}
            className={styles["blog-post"]}
            key={blog.id}
          >
            <BlogCard blog={blog} amplitudePageName={amplitudePageName} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default RelatedPosts;
